module.exports = __webpack_public_path__ + "static/media/doughnut.dbe85726.svg";